import once from 'once';
import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const StatsBox = ({ number, suffix, secondaryText, duration }) => (
  <>
    <p className="text-4xl lg:text-6xl font-semibold text-primary">
      <CountUp end={number} suffix={suffix} duration={duration}>
        {({ countUpRef, start }) => {
          const cb = once(start);
          return (
            <>
              <VisibilitySensor onChange={isVisible => isVisible && cb()}>
                <span ref={countUpRef} />
              </VisibilitySensor>
            </>
          );
        }}
      </CountUp>
    </p>
    <p className="font-semibold mb-6">{secondaryText}</p>
  </>
);

export default StatsBox;
